import React, { useEffect } from "react"
import Layout from "~/components/Layout";
import { useLang } from "~/hooks/useLang";
import AuditUserGroupReportTable from "../components/UserGroup";

export default function AuditUserGroupReport() {
    const { translate } = useLang();

    useEffect(() => {
        document.title = translate('User Group report Audit - Dispatch System')
    }, [])
    return (
        <Layout marginLayout={true}>
            <AuditUserGroupReportTable />
        </Layout>
    )
}